import React, { useState, useEffect } from "react";
import Panel from "../Solar/Panel.png";
import Inverter from "../Solar/Inverter.png";

export default function Solarjson() {
  // State for theme
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const documentTheme = document.documentElement.classList.contains("dark")
      ? "dark"
      : "light";
    //setTheme(savedTheme || documentTheme || "light");
    const initialTheme = savedTheme || documentTheme;
setTheme(initialTheme);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const newTheme = document.documentElement.classList.contains("dark")
            ? "dark"
            : "light";
          setTheme(newTheme);
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });

    return () => observer.disconnect();
  }, []);

  // Function to get theme variables
  const getThemeVar = (varName) => {
    return `var(${varName})`;
  };

  // Sample data for all panels
  const [inverters, setInverters] = useState([
    {
      id: 1,
      name: "INV-1",
      fcb: "FCB-1",
      lt: "LT-1",
      point: "P1",
      tx: "TX-1",
      feedPoint: "P1",
      inc: "INC-1",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "red",
    },
    {
      id: 2,
      name: "INV-2",
      fcb: "FCB-2",
      lt: "LT-2",
      point: "P2",
      tx: "TX-2",
      feedPoint: "21FB",
      inc: "INC-2",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
    {
      id: 3,
      name: "INV-3",
      fcb: "FCB-3",
      lt: "LT-3",
      point: "P3",
      tx: "TX-3",
      feedPoint: "32FB",
      inc: "INC-3",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
    {
      id: 4,
      name: "INV-4",
      fcb: "FCB-4",
      lt: "LT-4",
      point: "P4",
      tx: "TX-4",
      feedPoint: "P16",
      inc: "INC-4",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
    {
      id: 5,
      name: "INV-5",
      fcb: "FCB-5",
      lt: "LT-5",
      point: "P5",
      tx: "TX-5",
      feedPoint: "2FB",
      inc: "INC-5",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
    {
      id: 6,
      name: "INV-6",
      fcb: "FCB-6",
      lt: "LT-6",
      point: "P6",
      tx: "TX-6",
      feedPoint: "3FB",
      inc: "INC-6",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
    {
      id: 7,
      name: "INV-7",
      fcb: "FCB-7",
      lt: "LT-7",
      point: "P7",
      tx: "TX-7",
      feedPoint: "8FB",
      inc: "INC-7",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
    {
      id: 8,
      name: "INV-8",
      fcb: "FCB-8",
      lt: "LT-8",
      point: "P8",
      tx: "TX-8",
      feedPoint: "9FB",
      inc: "INC-8",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
    {
      id: 9,
      name: "INV-9",
      fcb: "FCB-9",
      lt: "LT-9",
      point: "P9",
      tx: "TX-9",
      feedPoint: "5FB",
      inc: "INC-9",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
    {
      id: 10,
      name: "INV-10",
      fcb: "FCB-10",
      lt: "LT-10",
      point: "P10",
      tx: "TX-10",
      feedPoint: "11FB",
      inc: "INC-10",
      power: "0.00 KW",
      energy: "0.00 KWh",
      status: "green",
    },
  ]);

  const [htPanel, setHtPanel] = useState({
    name: "HT_PANEL",
    fcb: "FCB-21",
    point: "P27",
    power: "0.00 KW",
    energy: "0.00 KWh",
  });

  const getStatusColor = (status) => {
    return status === "red" ? getThemeVar("--RedBaseColor") : getThemeVar("--GreenBaseColor");
  };

  // Inverter component with all related elements in a vertical flow but arranged horizontally
  const InverterColumn = ({ inverter }) => (
    <div
      className="flex flex-col items-center"
      style={{ minWidth: "90px", margin: "0 20px" }}
    >
      <div className="flex items-center justify-center mb-4 relative">
        {/* Vertical Line */}
        <div
          style={{
            width: "3px",
            height: "50px",
            backgroundColor: getThemeVar("--RedBaseColor"),
          }}
        ></div>
        {/* Power and Energy Readings - Positioned to the side */}
        <div
          className="flex flex-col"
          style={{ marginLeft: "30px", position: "relative", top: "-40px" }}
        >
          <div
            style={{
              backgroundColor: getThemeVar("--SecondaryBackground"),
              color: getThemeVar("--PrimaryText"),
              padding: "0px 6px",
              width: "63px",
              textAlign: "right",
              marginBottom: "0px",
              fontSize: "14px",
              border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
              marginRight: "-40px",
            }}
          >
            {inverter.power}
          </div>
          <div
            style={{
              backgroundColor: getThemeVar("--SecondaryBackground"),
              color: getThemeVar("--PrimaryText"),
              padding: "0px 6px",
              width: "63px",
              textAlign: "right",
              fontSize: "14px",
              border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
              marginRight: "-40px",
            }}
          >
            {inverter.energy}
          </div>
        </div>
      </div>
      {/* INC Component - With value in front of square */}
      <div className="flex items-center justify-center mb-6 w-full">
        <div className="flex items-center">
          <div
            style={{
              width: "25px",
              height: "25px",
              backgroundColor:
                inverter.status === "red"
                  ? getThemeVar("--RedBaseColor")
                  : getThemeVar("--GreenBaseColor"),
              border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "-10px",
              marginTop: "-38px",
            }}
          ></div>
          <div
            style={{
              marginLeft: "-10px",
              fontSize: "12px",
              position: "relative",
              top: "-18px",
              color: getThemeVar("--PrimaryText"),
            }}
          >
            {inverter.inc}
          </div>
        </div>
      </div>
      {/* Centered Vertical Line */}
      <div className="flex items-center justify-center mb-6">
        <div
          style={{
            width: "3px",
            height: "50px",
            backgroundColor:
              inverter.status === "red"
                ? getThemeVar("--RedBaseColor")
                : getThemeVar("--GreenBaseColor"),
            marginTop: "-15px",
          }}
        ></div>
      </div>
      {/* Feed Point - Centered */}
      <div
        className="mb-6 text-center"
        style={{
          fontSize: "12px",
          marginLeft: "-35px",
          textAlign: "left",
          minWidth: "30px",
          color: getThemeVar("--YellowBaseColor"),
          fontWeight: "bold",
          position: "relative",
          top: "-20px",
        }}
      >
        {inverter.feedPoint}
      </div>
      {/* TX Component - Centered */}
      <div className="flex flex-col items-center mb-6">
        {/* Circle and TX Text */}
        <div className="flex items-center justify-center mb-6">
          {/* TX Label */}
          <div
            style={{
              fontSize: "12px",
              marginLeft: "-35px",
              textAlign: "left",
              minWidth: "30px",
              position: "relative",
              bottom: "-20px",
              color: getThemeVar("--PrimaryText"),
            }}
          >
            {inverter.tx}
          </div>

          {/* Status Circle */}
          <div
            style={{
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              backgroundColor:
                inverter.status === "red"
                  ? getThemeVar("--RedBaseColor")
                  : getThemeVar("--GreenBaseColor"),
              border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
              marginLeft: "-12px",
              marginTop: "-30px",
            }}
          ></div>
        </div>
        {/* Vertical Line with P1, P2 */}
        <div className="flex items-center justify-center mb-6">
          {/* Vertical Line */}
          <div
            style={{
              width: "3px",
              height: "50px",
              backgroundColor:
                inverter.status === "red"
                  ? getThemeVar("--RedBaseColor")
                  : getThemeVar("--GreenBaseColor"),
            }}
          ></div>
          {/* P1, P2 Label */}
          <div
            style={{
              marginLeft: "-30px",
              fontSize: "12px",
              position: "relative",
              top: "-20px",
              color: getThemeVar("--YellowBaseColor"),
              fontWeight: "bold",
            }}
          >
            {inverter.point}
          </div>
        </div>
        {/* Square Element - Centered */}
        <div className="flex items-center justify-center mb-6">
          <div
            style={{
              width: "25px",
              height: "25px",
              backgroundColor:
                inverter.status === "red"
                  ? getThemeVar("--RedBaseColor")
                  : getThemeVar("--GreenBaseColor"),
              border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
              marginLeft: "-10px",
              marginTop: "-25px",
            }}
          ></div>
        </div>
      </div>
      {/* FCB/LT Container - Centered */}
      <div className="flex items-center justify-center mb-4 w-full">
        <div className="flex items-start">
          {/* Vertical line */}
          <div
            style={{
              width: "3px",
              height: "50px",
              backgroundColor:
                inverter.status === "red"
                  ? getThemeVar("--RedBaseColor")
                  : getThemeVar("--GreenBaseColor"),
              marginRight: "10px",
            }}
          ></div>
          {/* FCB and LT text */}
          <div style={{ fontSize: "13px" }}>
            <div
              style={{
                marginLeft: "-12px",
                fontSize: "12px",
                position: "relative",
                top: "-65px",
                color: getThemeVar("--PrimaryText"),
              }}
            >
              {inverter.lt}
            </div>
            <div
              style={{
                marginLeft: "-20px",
                fontSize: "12px",
                position: "relative",
                top: "-50px",
                color: getThemeVar("--PrimaryText"),
              }}
            >
              {inverter.fcb}
            </div>
          </div>
        </div>
      </div>
      {/* Inverter Box - Centered */}
      <div className="flex flex-col items-center w-full">
        {/* Inverter Image */}
        <div className="h-10 mb-10 text-center w-full">
          <img
            src={Inverter}
            alt="Inverter"
            style={{
              height: "140%",
              width: "80%",
              objectFit: "contain",
              margin: "0 auto",
              marginLeft: "-100px",
              marginTop: "-25px",
              filter: theme === "dark" ? "invert(1)" : "none",
            }}
          />
        </div>
        {/* Connection Line and Inverter Name - Centered */}
        <div className="flex items-center justify-center mb-4 w-full">
          <div className="flex items-start">
            {/* Vertical line */}
            <div
              style={{
                width: "3px",
                height: "50px",
                backgroundColor:
                  inverter.status === "red"
                    ? getThemeVar("--RedBaseColor")
                    : getThemeVar("--GreenBaseColor"),
                marginRight: "10px",
                marginTop: "-4px",
              }}
            ></div>
            {/* Inverter Name */}
            <div
              style={{
                marginLeft: "-12px",
                fontSize: "14px",
                position: "relative",
                top: "-30px",
                color: getThemeVar("--PrimaryText"),
              }}
            >
              {inverter.name}
            </div>
          </div>
        </div>
        {/* Solar Panel Image - Centered */}
        <div
          className="border rounded w-20 h-16 relative overflow-auto"
          style={{
            borderColor: getThemeVar("--LK_BrandBlue_1"),
            backgroundColor: getThemeVar("--SecondaryBackground"),
          }}
        >
          <img
            src={Panel}
            alt="Panel"
            style={{
              height: "80%",
              width: "90%",
              objectFit: "contain",
              margin: "0 auto",
              display: "block",
              marginLeft: "-40px",
              marginTop: "-14px",
              filter: theme === "dark" ? "invert(1)" : "none",
            }}
          />
        </div>
      </div>
    </div>
  );

  // Main dashboard layout
  return (
    <div
      style={{
        fontFamily: "Roboto, sans-serif",
        backgroundColor: getThemeVar("--SecondaryBackground"),
        color: getThemeVar("--PrimaryText"),
        height: "100vh",
        width: "100%",
        padding: "15px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        overflow: "auto",
      }}
    >
      {/* Main content */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          boxSizing: "border-box",
          overflow: "auto",
          flex: "1",
        }}
      >
        {/* HT Panel - horizontal layout with increased sizes */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "30px",
            marginBottom: "20px",
            width: "100%",
            overflow: "auto",
            boxSizing: "border-box",
          }}
        >
          {/* Left side labels */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              marginRight: "10px",
              color: getThemeVar("--PrimaryText"),
            }}
          >
            <div style={{ fontWeight: "bold", fontSize: "14px" }}>
              {htPanel.fcb}
            </div>
            <div style={{ fontSize: "14px" }}>{htPanel.name}</div>
          </div>
          {/* Center red line with square */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "3px",
                height: "38px",
                backgroundColor: getThemeVar("--RedBaseColor"),
              }}
            ></div>
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: getThemeVar("--RedBaseColor"),
                border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
              }}
            ></div>
            <div
              style={{
                width: "3px",
                height: "38px",
                backgroundColor: getThemeVar("--RedBaseColor"),
              }}
            ></div>
          </div>
          {/* Right side point name and values */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "10px",
            }}
          >
            <div
              style={{
                color: getThemeVar("--YellowBaseColor"),
                fontWeight: "bold",
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              {htPanel.point}
            </div>
            <div
              style={{
                backgroundColor: getThemeVar("--SecondaryBackground"),
                color: getThemeVar("--PrimaryText"),
                padding: "0px 6px",
                width: "60px",
                textAlign: "right",
                marginBottom: "0px",
                fontSize: "14px",
                border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
              }}
            >
              {htPanel.power}
            </div>
            <div
              style={{
                backgroundColor: getThemeVar("--SecondaryBackground"),
                color: getThemeVar("--PrimaryText"),
                padding: "0px 6px",
                width: "60px",
                textAlign: "right",
                fontSize: "14px",
                border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
              }}
            >
              {htPanel.energy}
            </div>
          </div>
        </div>
        {/* Bus bar */}
        <div
          style={{
            position: "relative",
            width: "100%",
            marginTop: "-20px",
            marginBottom: "0px",
          }}
        >
          {/* Text positioned above the bus bar */}
          <div
            style={{
              position: "absolute",
              top: "-20px",
              right: "250px",
              color: getThemeVar("--PrimaryText"),
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            BUS-1, 33KV
          </div>
          {/* Red bus bar */}
          <div
            style={{
              height: "6px",
              backgroundColor: getThemeVar("--RedBaseColor"),
              width: "100%",
            }}
          ></div>
        </div>
        {/* Inverter columns - scrollable container */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: "1",
            overflow: "auto",
          }}
        >
          {/* Horizontal inverter layout */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              overflowX: "auto",
              width: "100%",
              justifyContent: "flex-start",
              paddingLeft: "20px",
              paddingBottom: "10px",
              flex: "1",
            }}
          >
            {inverters.map((inverter) => (
              <InverterColumn key={inverter.id} inverter={inverter} />
            ))}
          </div>
          {/* LT readings - horizontal */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "10px",
              width: "100%",
              marginTop: "15px",
              marginBottom: "20px",
            }}
          >
            {inverters.map((inverter) => (
              <div
                key={`lt-${inverter.id}`}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  minWidth: "100px",
                }}
              >
                <div
                  style={{
                    marginBottom: "4px",
                    fontSize: "13px",
                    color: getThemeVar("--PrimaryText"),
                  }}
                >
                  {inverter.lt}
                </div>
                <div
                  style={{
                    backgroundColor: getThemeVar("--SecondaryBackground"),
                    color: getThemeVar("--PrimaryText"),
                    padding: "0px 6px",
                    width: "60px",
                    textAlign: "right",
                    marginBottom: "0px",
                    fontSize: "14px",
                    border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
                  }}
                >
                  {inverter.power}
                </div>
                <div
                  style={{
                    backgroundColor: getThemeVar("--SecondaryBackground"),
                    color: getThemeVar("--PrimaryText"),
                    padding: "0px 6px",
                    width: "60px",
                    textAlign: "right",
                    fontSize: "14px",
                    border: `1px solid ${getThemeVar("--GreyVariation_2")}`,
                  }}
                >
                  {inverter.energy}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Navigation button */}
      <div
        style={{
          position: "absolute",
          bottom: "15px",
          right: "15px",
        }}
      >
        <button
          style={{
            backgroundColor: getThemeVar("--GreyVariation_2"),
            color: getThemeVar("--White"),
            padding: "6px 12px",
            fontSize: "16px",
            fontWeight: "bold",
            border: "none",
            cursor: "pointer",
          }}
        >
          ≫
        </button>
      </div>
      {/* Theme toggle button - optional */}
      <div
        style={{
          position: "absolute",
          top: "15px",
          right: "15px",
        }}
      >
        {/* <button
          onClick={() => {
            const newTheme = theme === "light" ? "dark" : "light";
            setTheme(newTheme);
            document.documentElement.classList.toggle("dark");
            document.documentElement.classList.toggle("light");
            localStorage.setItem("theme", newTheme);
          }}
          style={{
            backgroundColor: getThemeVar("--LK_BrandBlue"),
            color: getThemeVar("--White"),
            padding: "6px 12px",
            fontSize: "14px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          {theme === "light" ? "Dark Mode" : "Light Mode"}
        </button> */}
      </div>
    </div>
  );
}
